import { useContext } from 'react';
import { useStore } from 'zustand';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';
import { ChannelManager } from 'app/typings/channelManagers';

import { ButtonAutoInventory } from '../../../_common/ButtonAutoInventory/ButtonAutoInventory';
import { inventoryStore } from '../../InventoryStore';

import './InventoryHeader.scss';
import { TimePeriod } from './TimePeriod';
import { ButtonDefaultDiscount } from './_components/ButtonDefaultDiscount';
import { DateRangeControl } from './_components/DateRangeControl';
import { EditInventoryActions } from './_components/EditInventoryActions';
import { PackageSelector } from './_components/PackageSelector/PackageSelector';
import { SettingsDropdown } from './_components/SettingsDropdown';

type InventoryHeaderProps = {
  startTransition: React.TransitionStartFunction;
};

export const InventoryHeader = ({ startTransition }: InventoryHeaderProps) => {
  const isEditMode = useStore(inventoryStore, (state) => state.isEditMode);
  const setIsPricingRuleOpen = useStore(
    inventoryStore,
    (state) => state.setPricingRuleModalOpen
  );
  const setIsAutoInventoryModalOpen = useStore(
    inventoryStore,
    (state) => state.setAutoInventoryModalOpen
  );
  const { hotelInfo: hotel } = useContext(HotelContext);
  const { publishedPackages: packages, hasAtLeastOneDayPackage } =
    useContext(LegacyHotelContext);
  const hasChannelManager = hotel?.channelManager !== ChannelManager.NONE;
  const hasPRActivated = packages.some(
    (pkg) => !!pkg.autoDiscountRate || !!pkg.lastMinuteAutoDiscountRate
  );

  return (
    <div className="inventory-header">
      <div className="inventory-header-action">
        <div className="left-action">
          {!hasAtLeastOneDayPackage && (
            <PackageSelector startTransition={startTransition} />
          )}
          <DateRangeControl startTransition={startTransition} />
        </div>

        <div className="right-action">
          {!isEditMode && (
            <>
              {!hasChannelManager && !hasAtLeastOneDayPackage && (
                <ButtonAutoInventory
                  hasAutoInventoryActivated={
                    hotel?.stockScrapperEnabled ?? false
                  }
                  setIsAutoInventoryModalOpen={() =>
                    setIsAutoInventoryModalOpen(true)
                  }
                />
              )}
              {hasChannelManager && !hasAtLeastOneDayPackage && (
                <ButtonDefaultDiscount
                  hasActivatedPricingRule={hasPRActivated}
                  setIsPricingRuleModalOpen={setIsPricingRuleOpen}
                />
              )}
              <SettingsDropdown />
            </>
          )}
          <EditInventoryActions startTransition={startTransition} />
        </div>
      </div>
      <TimePeriod />
    </div>
  );
};
